'use client';

import { FC } from 'react';
import { Container } from 'atoms/Container';
import { HeadLine } from 'atoms/Typography/Typography';
import { Recommendations } from 'pages/ProductDetail/Recommendations/Recommendations';
import { IAdaptedListProduct } from 'commerce/scayle/utils/adapter/types';
import styles from './styles.module.css';

interface ProductTileSliderProps {
  products?: IAdaptedListProduct[];
  title?: string;
  titleColor?: string;
  backgroundColor?: string;
}

export const ProductTileSlider: FC<ProductTileSliderProps> = ({
  products,
  title,
  titleColor,
  backgroundColor,
}) => {
  return (
    <Container className={styles.root} style={{ background: backgroundColor }}>
      <HeadLine
        type="sm"
        weight="bold"
        className={styles.title}
        style={{ color: titleColor }}
      >
        {title}
      </HeadLine>
      <Recommendations products={products || []} />
    </Container>
  );
};
